import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import '../styles/PolicyPages.css';

const TermsConditions = () => {
  return (
    <div className="policy-page">
      <div className="policy-container">
        <Link to="/" className="back-link">← Back to Home</Link>
        
        <h1 className="policy-title">Terms & Conditions</h1>
        <p className="policy-updated">Last updated: February 2025</p>

        <section className="policy-section">
          <p>Please read these Terms & Conditions carefully before placing an order or using the QuitStick website. By accessing our website or purchasing our products, you agree to be bound by these terms.</p>
        </section>

        <section className="policy-section">
          <h2>1. About QuitStick</h2>
          <p>QuitStick is a nicotine-free, tobacco-free behavioral replacement tool designed to help smokers break the habitual and physical rituals associated with smoking. QuitStick is not a medical device, pharmaceutical product, or nicotine replacement therapy (NRT). It is not intended to diagnose, treat, cure, or prevent any disease or condition.</p>
        </section>

        <section className="policy-section">
          <h2>2. Eligibility</h2>
          <p>QuitStick is available for purchase by anyone looking to reduce or eliminate their smoking habit. By placing an order, you confirm that the information provided is accurate and complete.</p>
        </section>

        <section className="policy-section">
          <h2>3. Product Use</h2>
          <p>QuitStick is designed for personal use as a behavioral aid. It should be used responsibly and in accordance with the usage guidance provided. QuitStick is not a substitute for professional medical advice. If you are seeking help with nicotine addiction or related health conditions, we encourage you to consult a qualified healthcare professional.</p>
        </section>

        <section className="policy-section">
          <h2>4. Orders & Payment</h2>
          <p>All orders are subject to acceptance and availability. We reserve the right to cancel or refuse any order at our discretion. Prices are listed in Indian Rupees (INR) and include all applicable taxes. Shipping is free on all orders.</p>
        </section>

        <section className="policy-section">
          <h2>5. No Returns & No Refunds</h2>
          <p>Due to the consumable and personal hygiene nature of our products, <strong>we do not accept returns or offer refunds</strong> under any circumstances once an order has been placed and dispatched. Please review your order carefully before confirming your purchase. See our full Cancellation & Refunds Policy for details.</p>
        </section>

        <section className="policy-section">
          <h2>6. Intellectual Property</h2>
          <p>All content on the QuitStick website — including but not limited to text, images, logos, design elements, and product descriptions — is the intellectual property of QuitStick and may not be reproduced, distributed, or used without prior written permission.</p>
        </section>

        <section className="policy-section">
          <h2>7. Limitation of Liability</h2>
          <p>QuitStick shall not be liable for any indirect, incidental, or consequential damages arising from the use or inability to use our products or website. Our total liability in any matter related to our products is limited to the amount paid for the specific product in question.</p>
        </section>

        <section className="policy-section">
          <h2>8. Changes to Terms</h2>
          <p>We reserve the right to update these Terms & Conditions at any time. Continued use of our website or products after any changes constitutes your acceptance of the revised terms.</p>
        </section>

        <section className="policy-section">
          <h2>9. Governing Law</h2>
          <p>These Terms & Conditions are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts in India.</p>
        </section>
      </div>
      
      <Footer />
    </div>
  );
};

export default TermsConditions;
